import { en } from './en';
import { th } from './th';

export type Language = 'th' | 'en';
type TranslationKey = keyof typeof th;

const dictionaries = { th, en } as const;
let language: Language = readLanguage();

function readLanguage(): Language {
  return localStorage.getItem('language') === 'en' ? 'en' : 'th';
}

export function currentLanguage(): Language {
  return language;
}

export function t(key: TranslationKey): string {
  return dictionaries[language][key];
}

export function tFor(nextLanguage: Language, key: TranslationKey): string {
  return dictionaries[nextLanguage][key];
}

export function applyLang(nextLanguage: Language): void {
  language = nextLanguage;
  localStorage.setItem('language', language);
  document.documentElement.lang = language;

  document.querySelectorAll<HTMLElement>('[data-t]').forEach((element) => {
    const key = element.dataset.t as TranslationKey | undefined;
    if (key) element.textContent = t(key);
  });
}
